<script setup lang="ts">
import { Button } from 'ant-design-vue';

import type { FileContentFragmentFragment, FileFragmentFragment } from '@/graphql/generated/graphql';
import CopyIconButton from '@/ui/CopyIconButton.vue';
import ModalButton from '@/ui/ModalButton.vue';
import LayoutLeftRight from '@/ui/LayoutLeftRight.vue';
import PreviewFile from '@/ui/PreviewFile/index.vue';

defineProps<{
  file: FileFragmentFragment;
  fileContent: FileContentFragmentFragment;
}>();

const isFileError = ref(false);
const env = useEnv();
</script>

<template>
  <ModalButton
    title="File content"
    description="View the content of the file"
  >
    <template #button="{ onOpen }">
      <Button @click="onOpen">
        View
      </Button>
    </template>
    <LayoutLeftRight>
      <template #left>
        <div class="flex min-h-0 min-w-0 flex-1 flex-col">
          <p class="mb-3 shrink-0 text-xs text-gray-500">
            {{ file.original_name }}
          </p>
          <div class="min-h-0 flex-1 overflow-auto">
            <PreviewFile
              v-model:is-error="isFileError"
              :url="`${env.domains.api}/v2/file/${file.id}`"
              :ext="file.ext"
            />
          </div>
        </div>
      </template>
      <template #right>
        <div class="flex min-h-0 min-w-0 flex-1 flex-col">
          <div class="mb-4 flex shrink-0 items-center gap-4">
            <h1 class="text-lg font-bold">File content type: {{ fileContent.content_type }}</h1>
            <CopyIconButton :value="fileContent.content" />
          </div>
          <div class="min-h-0 flex-1 overflow-auto">
            <FileContentView :file-content="fileContent" />
          </div>
        </div>
      </template>
    </LayoutLeftRight>
  </ModalButton>
</template>